const ENVIRONMENT = process.env.NODE_ENV;

export default ENVIRONMENT;
